
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 12.5c1.138 0 2.8-.546 4.225-4.57.356-1.049.807-3.43 2.191-3.43s1.798 2.347 2.197 3.43C11.425 10.41 13.05 12.5 15 12.5","stroke":"currentColor","stroke-width":"1.3","stroke-linecap":"round"}})])
          )
        }
      }
    